import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getClaimChartImages } from '../../features/InfringementDetection/api/claimChart';
import { setClaimImageAreaTags, setClaimImages, setClaimImageTags } from '../slices/claimChartSlice';

export const fetchClaimsImages = createAsyncThunk(
  'claims/GetClaimChartImages',
  async (payload: { workflowId: string }, { rejectWithValue, dispatch }) => {
    try {
      const data = await getClaimChartImages(payload.workflowId);

      if (data) {
        data.images.forEach(image => {
          dispatch(
            setClaimImageTags({
              imageId: image.imageId,
              tags: image.imageTags.map(t => ({
                tagName: t.tag,
                tagId: t.tagId,
              })),
            }),
          );

          image.imageAreaTags.forEach(a => {
            dispatch(
              setClaimImageAreaTags({
                imageId: image.imageId,
                area: {
                  tags: a.tags.map(t => ({ id: t.tagId, name: t.tag })),
                  id: a.imageTagAreaId,
                  x: a.tagArea.xCoordinate,
                  y: a.tagArea.yCoordinate,
                  width: a.tagArea.width,
                  height: a.tagArea.height,
                  color: a.colour,
                },
              }),
            );
          });

          dispatch(
            setClaimImages({
              imageId: image.imageId,
              imageUrl: image.imageUrl,
            }),
          );
        });
      }

      return data;
    } catch (err) {
      const error: AxiosError = err as AxiosError;

      return rejectWithValue({
        error: error.response?.data ? error.response?.data : 'Oops.. something went wrong',
      });
    }
  },
);
